// These are all in the database
const SafePlatformNames = [
    'campaignMonitor',
    'clubReady',
    'facebook',
    'facebookMarketing',
    'fitware',
    'four51',
    'glofox',
    'google',
    'googleAdWords',
    'googleMyBusiness',
    'instagram',
    'kite',
    'linkedIn',
    'mailchimp',
    'mailOps',
    'marianaTek',
    'mindbody',
    'print',
    'sendgrid',
    'tiktok',
    'tv',
    'twitter',
    'video',
    'website',
    'zenoti',
] as const;

// These are all not in the database
const UnsafeServiceNames = ['local', 'media', 'snapchat', 'mobipost'] as const;

const AllServiceNames = [...SafePlatformNames, ...UnsafeServiceNames] as const;

export type ServiceName = (typeof AllServiceNames)[number];

export function isServiceName(name: string): name is ServiceName {
    return AllServiceNames.includes(name as ServiceName);
}

export type PlatformName = (typeof SafePlatformNames)[number];
export const PlatformNames: ReadonlyArray<PlatformName> = SafePlatformNames;

export type PublishableService = Extract<
    ServiceName,
    | 'campaignMonitor'
    | 'clubReady'
    | 'facebook'
    | 'fitware'
    | 'four51'
    | 'glofox'
    | 'googleMyBusiness'
    | 'instagram'
    | 'kite'
    | 'linkedIn'
    | 'local'
    | 'mailchimp'
    | 'marianaTek'
    | 'mindbody'
    | 'print'
    | 'sendgrid'
    | 'twitter'
    | 'zenoti'
>;

const PublishableServiceNames = [
    'campaignMonitor',
    'clubReady',
    'facebook',
    'fitware',
    'four51',
    'glofox',
    'googleMyBusiness',
    'instagram',
    'kite',
    'linkedIn',
    'local',
    'mailchimp',
    'marianaTek',
    'mindbody',
    'print',
    'sendgrid',
    'twitter',
    'zenoti',
];

export function isPublishableServiceName(name: string): name is PublishableService {
    return PublishableServiceNames.includes(name as PublishableService);
}

export type ReportableService = Extract<
    ServiceName,
    | 'campaignMonitor'
    | 'clubReady'
    | 'facebook'
    // Facebook Ads
    | 'facebookMarketing'
    | 'fitware'
    // Google Analytics
    | 'google'
    // Google Ads
    | 'googleAdWords'
    | 'instagram'
    | 'mailchimp'
    | 'sendgrid'
    | 'twitter'
>;

export const MultiImagePublishableServices = ['facebook', 'instagram', 'twitter', 'linkedIn'] as const;
